export const DAYS_SHORTCUTS = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
export const DAYS_NAMES = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
